export enum UserConditionType {
  TermsAndCondition,
  Announcement
}
